export const BANNER_WIDGET_ALT_TEXT = 'banner widget';

// assuming all widgets are rendered
export const DEFAULT_BANNER_WIDGET_INDEX = 7;

export const BANNER_WIDGET_HEIGHT = 100;
